<section class="about px-8">
  <h2 class="text-2xl mt-8">
    O nas
  </h2>
  <p class="mt-8 mb-8">
    Firma EuroContact działa na rynku już ponad 10 lat. Naszymi klientami jest większość sieci handlowych w Polsce, sklepy masarskie należące do zakładów mięsnych, firmy cateringowe oraz hotele. Bierzemy udział w targach branżowych i wystawach. Cieszymy się, kiedy nasi klienci są zadowoleni z naszych pojemników do lad chłodniczych, bo sukces naszych klientów to nasz sukces.
  </p>
</section>